import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import {reduxForm} from "redux-form";
import {GetInterfaceLang, addEmailTemplates, editEmailTemplates,deleteNotification, getNotificationOne, getEmailTemplates, addTranslationToNotifications, addNotificationBig, updateTranslationToNotifications, updateNotificationBig} from '../../actions/index';


class NotificationAdd extends Component {
    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props){
        super(props);
        this.state = {
            picture: '',
            lwv: ''
        }
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetInterfaceLang(token);
        this.props.getEmailTemplates(token);
        if(this.props.params.id_notification){
            this.props.getNotificationOne(token, this.props.params.id_notification).then((response)=>{
                if(response.payload.status == 200){
                    if(typeof response.payload.data.lwc == 'number'){
                        this.setState({lwv : response.payload.data.lwc})
                    }
                }
            });
        }
    }
    componentWillUnmount(){
        this.props.notification.one = {};
        this.props.notification.list = {};
    }
    delRule=()=>{
        let token = localStorage.getItem('id_token_admin');
        this.props.deleteNotification(token, this.props.params.id_notification).then((response)=>{
            if(response.payload.status == 204){
                $('#DelWord').modal('hide');
                this.context.router.push('/notifications/');
                this.props.getNotificationList(token);
            }
        });
    }
    delRuleOpenModal=()=>{
        $('#DelWord').modal('show');
    }
    closeModal=()=>{
        $('#DelWord').modal('hide');
    }
    circleFor=(arr, block)=>{
        for(let i=0; i<block.length; i++){
            let oneBlock = block[i];
            if($(oneBlock).find('textarea').val() == ''){
                $(oneBlock).addClass('has-error');
            }
        }
    }
    SubmitForm=(props)=>{
        $('.btn.btn-primary').prop("disabled", true);
        let token = localStorage.getItem('id_token_admin');
        let dataForm;

        this.circleFor([], $('.title_translate .addWordBlock'));
        this.circleFor([], $('.description_translate .addWordBlock'));
        
        if(typeof props.picture != 'string'){
            dataForm = new FormData();
            for(let i=0; i<Object.keys(props).length; i++){
                if(props[Object.keys(props)[i]] != undefined){
                    dataForm.append(Object.keys(props)[i], props[Object.keys(props)[i]]);
                }
            }
        }else{
            dataForm = props;
            delete dataForm.picture
        }
        if(this.state.lwv != ''){
            dataForm.lwc = Number(this.state.lwv);
        }
        if(this.props.params.id_notification){
            this.props.updateNotificationBig(token, dataForm, this.props.params.id_notification).then((resp)=>{
                if(resp.payload.status == 200){
                    this.props.lang.interface_lang.results.forEach((item)=>{
                        let translations= [];
                        if(item.is_active){
                            let obj = {
                                blang: item.id,
                                notification: resp.payload.data.id,
                                congratulation: $('.title_translate').find('.addWordBlock#' + item.id).find('textarea').val(),
                                advice: $('.description_translate').find('.addWordBlock#' + item.id).find('textarea').val(),
                            }
                            translations.push(obj)
                        }
                        for(let i=0; i<translations.length; i++){
                            let one = translations[i];
                            let item = _.findWhere(resp.payload.data.translations, {blang: one.blang});
                            if(_.findWhere(resp.payload.data.translations, {blang: one.blang})){
                                this.props.updateTranslationToNotifications(token, one, item.id);
                            }else {
                                this.props.addTranslationToNotifications(token, one, {blang: one.blang});
                            }
                        }
                    });
                    setTimeout(()=>{
                        this.context.router.push('/notifications/');
                    },1500)
                }
                $('.btn.btn-primary').prop("disabled", false);
            })
        }else{
            this.props.addNotificationBig(token, dataForm).then((resp)=>{
                if(resp.payload.status == 201){
                    this.props.lang.interface_lang.results.forEach((item)=>{
                        let translations = [];
                        if(item.is_active){
                            let obj = {
                                notification: resp.payload.data.id,
                                blang: item.id,
                                congratulation: $('.title_translate').find('.addWordBlock#' + item.id).find('textarea').val(),
                                advice: $('.description_translate').find('.addWordBlock#' + item.id).find('textarea').val(),
                            }
                            translations.push(obj)
                        }
                        for(let i=0; i<translations.length; i++){
                            let one = translations[i];
                            this.props.addTranslationToNotifications(token, one);
                        }
                    })
                    setTimeout(()=>{
                        this.context.router.push('/notifications/');
                    },1500)
                }
                $('.btn.btn-primary').prop("disabled", false);
            })
        }
    }
    getTitleById=(id, translations)=>{
        let result = '';
        translations.forEach(function(item, i){
            if(item.type == id) {
                result = item.name;
            }
        });
        return result
    }
    renderName=(id)=>{
        return this.getTitleById(parseInt(id), this.props.email.email_temp);
    }
    renderTranslate=(title)=>{
        let elem = this.props.lang.interface_lang.results;
        return elem.map((item)=>{
            if (item.is_active) {
                return (
                    <div className='row addWordBlock sentences' id={item.id} key={item.lang.id}>
                        <div className="col-md-4">
                            <label>{item.lang.name}</label>
                        </div>
                        {this.editTranslation(item.id, title)}
                    </div>
                )
            }
        });
    }
    removeClass=(e)=>{
        $('#' + e.target.name).closest('.sentences').removeClass('has-error')
    }
    editTranslation=(id, title)=>{
        if (this.props.params.id_notification) {
            let item = _.findWhere(this.props.notification.one.translations, {blang: id});
            if (_.findWhere(this.props.notification.one.translations, {blang: id})) {
                return (
                    <div className="col-md-4" key={item.id} id={item.id}>
                        <textarea className="form-control" name={item.id} defaultValue={item[title]}
                                  onChange={this.removeClass}/>
                    </div>
                )
            }
            else {
                return (
                    <div className="col-md-4" id={id}>
                        <textarea className="form-control" name={id} onChange={this.removeClass}/>
                    </div>
                )
            }
        } else {
            return (
                <div className="col-md-4" id={id}>
                    <textarea className="form-control" name={id} onChange={this.removeClass}/>
                </div>
            )
        }
    }
    handleChange=(event)=>{
        let obj = event.target.files[0];
        this.props.fields.picture.onChange(obj);

        this.setState({
            picture: obj.name
        })
    }
    lwv=(e)=>{
        this.setState({lwv: e.target.value});
    }
    render() {
        const { fields: {
            title, picture}, handleSubmit} = this.props;
        return (
            <div className="dashboard-wrapper">
                <p className="dashboard-title">{this.props.params.id_notification ? "Edit notification" : "Add notification"}</p>
                <p className="dashboard-text">Notification page</p>
                <form className="form_rule clearfix only_notific" onSubmit={handleSubmit(this.SubmitForm.bind(this))}>
                    <div className="col-md-12">
                        <div className="white-block block-4-8 clearfix">
                            <div className="clearfix blockTranslateRule">
                                <div className="row name_rule_block">
                                    <div className="col-md-4">
                                        <label htmlFor="title">Title</label>
                                    </div>
                                    <div className={ title.touched && !title.valid ? 'col-md-4 has-error' : 'col-md-4'}>
                                        <input type="text"
                                               id="title"
                                               placeholder="Title"
                                               {...title}
                                               className="form-control"
                                               name="title"
                                        />
                                    </div>
                                </div>
                                <div className='row clearfix'>
                                    <div className="col-md-4">
                                        <label htmlFor="flag">Picture</label>
                                    </div>
                                    <div className={ picture.touched && !picture.valid ? 'col-md-4 has-error' : 'col-md-4'}>
                                        <label htmlFor="picture" className="btn btn-primary pull-left">Choose</label>
                                        <input type="file"
                                               style={{display: 'none'}}
                                               name="picture"
                                               id="picture"
                                               onChange={this.handleChange}
                                        />
                                        <input type="text"
                                               placeholder="Picture"
                                               className="form-control"
                                               name="picture2"
                                               id="picture2"
                                               disabled
                                               value = {this.state.picture || picture.value}
                                        />
                                    </div>
                                </div>
                                <div className='row clearfix'>
                                    <div className="col-md-4">
                                        <label htmlFor="flag">Learned words value</label>
                                    </div>
                                    <div className="col-md-4">
                                        <input
                                            type="number"
                                            className="form-control"
                                            onChange={(e)=>{this.lwv(e)}}
                                            id="lwv"
                                            name="lwv"
                                            value={this.state.lwv}
                                        />
                                    </div>
                                </div>
                                <div className="clearfix blockTranslate border-bottom-none title_translate">
                                    <p className="title">Translate Title</p>
                                    {this.props.lang.interface_lang.results && this.props.notification.one ?
                                        <div className="col-md-12">
                                            {this.renderTranslate('congratulation')}
                                        </div>
                                        : ""
                                    }
                                </div>
                                <div className="clearfix blockTranslate border-bottom-none description_translate">
                                    <p className="title">Translate Description</p>
                                    {this.props.lang.interface_lang.results && this.props.notification.one ?
                                        <div className="col-md-12">
                                            {this.renderTranslate('advice')}
                                        </div>
                                        : ""
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="white-block clearfix">
                            <div className="col-md-12 text-center button-group">
                                <Link to={"/notifications/"} className="btn btn-default">Cancel</Link>
                                {this.props.params.id_notification ?
                                    <button type="button" onClick={this.delRuleOpenModal} className="btn btn-danger">Delete</button>
                                    :""}
                                <button type="submit" className="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </form>

                <div className="modal fade" id="DelWord" tabIndex="-1" role="dialog" aria-labelledby="DelWordLabel">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body text-center">
                                <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#DelWord"></span>
                                <p>Do you really want to delete this notification {this.props.notification.one ? <span>{this.props.notification.one.title}</span> : ""}?</p>
                            </div>
                            <div className="modal-footer text-center">
                                <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                <button onClick={this.delRule} type="button" className="btn btn-primary">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const validate=(values)=>{
    const errors = {};
    if(!values.title){
        errors.title = 'Enter a title'
    }
    if(!values.picture){
        errors.picture = 'Enter a title'
    }
    return errors;
}


const mapStateToProps=(state)=>{
    return{
        lang: state.lang,
        notification: state.notification,
        initialValues: {
            title: state.notification.one ? state.notification.one.title : '',
            picture: state.notification.one ? state.notification.one.picture : ''
        }
    }
}

export default reduxForm({
    form: 'Add Notification',
    fields: ['picture', 'title'],
    validate
}, mapStateToProps, {GetInterfaceLang, addEmailTemplates, editEmailTemplates,deleteNotification, getNotificationOne, getEmailTemplates, addTranslationToNotifications, addNotificationBig, updateTranslationToNotifications, updateNotificationBig})(NotificationAdd);




// WEBPACK FOOTER //
// ./src/components/notifications/notificationAdd.js